import React, { useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ProblemStatement from './components/ProblemStatement';
import Features from './components/Features';
import TeamFeatures from './components/TeamFeatures';
import Contact from './components/Contact';
import CTA from './components/CTA';
import Footer from './components/Footer';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsConditions from './components/TermsConditions';
import CookiePolicy from './components/CookiePolicy';
import Disclaimer from './components/Disclaimer';
import './App.css';

function App() {
  const pathname = window.location.pathname;

  useEffect(() => {
    // Handle /download deeplink
    if (pathname === '/download') {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      // Check for Apple devices (iOS and macOS)
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        window.location.href = 'https://apps.apple.com/in/app/scan2card/id6752845236';
        return;
      }

      if (/Macintosh|MacIntel|MacPPC|Mac68K/.test(userAgent)) {
        window.location.href = 'https://apps.apple.com/in/app/scan2card/id6752845236';
        return;
      }

      // For Android and all other devices, open Play Store
      window.location.href = 'https://play.google.com/store/apps/details?id=com.scan2card.quickleads';
    }
  }, [pathname]);

  if (pathname === '/privacy-policy') {
    return (
      <div className="App">
        <Navbar />
        <PrivacyPolicy />
        <Footer />
      </div>
    );
  }

  if (pathname === '/terms-conditions') {
    return (
      <div className="App">
        <Navbar />
        <TermsConditions />
        <Footer />
      </div>
    );
  }

  if (pathname === '/cookie-policy') {
    return (
      <div className="App">
        <Navbar />
        <CookiePolicy />
        <Footer />
      </div>
    );
  }

  if (pathname === '/disclaimer') {
    return (
      <div className="App">
        <Navbar />
        <Disclaimer />
        <Footer />
      </div>
    );
  }

  return (
    <div className="App">
      <Navbar />
      <Hero />
      <ProblemStatement />
      <Features />
      <TeamFeatures />
      <Contact />
      <CTA />
      <Footer />
    </div>
  );
}

export default App;
